import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { fadeInFromBottom } from '../animations';

export const storyTextmedia = () => {
  const sections = $$('.story-textmedia');

  if (sections.length) {
    sections.forEach(section => {
      fadeInFromBottom($$('.story-textmedia__inner', section));
    });

    const getImageContainerWidth = () => {
      const imageContainer = $('.story-textmedia__image-animated');

      if (imageContainer) {
        const w = imageContainer.offsetWidth;
        return -w;
      }
    };

    const frameCount = 9;
    const offsetValue = getImageContainerWidth();
    const imageImg = $('.story-textmedia__image-img');
    const imageAnimated = $('.story-textmedia__image-animated');

    if (imageImg && imageAnimated) {
      gsap.to(imageImg, {
        marginLeft: () => offsetValue * frameCount + 'px',
        ease: 'steps(' + frameCount + ')',
        duration: 10,
        repeat: -1,
        scrollTrigger: {
          trigger: imageAnimated,
          start: 'top 90%',
          end: 'bottom 10%',
          toggleActions: 'play pause resume reset',
        },
      });
    }
  }
};
